import { Stack, Text } from "@mantine/core";
import classes from "./TripPolicyDrawer.module.css";

const TripDrawerField = ({ label, value, highlight }) => (
  <Stack gap={4}>
    <Text size="xs" c="dimmed" tt="uppercase" fw={600}>
      {label}
    </Text>
    <Text size="sm" fw={600} c={highlight || undefined} className={classes.fieldValue}>
      {value ?? "—"}
    </Text>
  </Stack>
);

export default TripDrawerField;
